module.exports = __webpack_public_path__ + "img/logo-top.926ec7bd.png";